'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CustomizableCalendarDay = {};

exports.__exports = CustomizableCalendarDay;
